import "./Result.scss";
import React from "react";
import { observer } from "mobx-react";
import { Chart, Button, IonIcon } from "../lib";
import lifecycleMatrix from "./lifecycle_matrix.json";
import bookImg from "../assets/book.jpg";
import { resultStore } from "../stores";
import { BOOK_LINK } from "../constants";

const Result = ({ questions, phaseId, side, full }) => {
  const {
    phase,
    priority_focus,
    general_characteristics,
    foundations,
    leadership,
    ministry_strategy,
    systems,
    staffing_structure,
    finances,
    key_next_steps,
  } = lifecycleMatrix[phaseId];
  return (
    <div className="Result">
      <div className="Result_wrapper">
        <div className="Result_phase">
          <p>
            Your assessment results indicate your church is most strongly
            <br />
            exhibiting characteristics of the {phase} phase of the church life
            cycle.
          </p>
          <h1>{phase} Phase</h1>
        </div>
        <Chart questions={questions} side={side} bars />
        <div className="Result_info">
          <div className="Result_keynextsteps">
            <h3>Recommendation</h3>
            <h2>{key_next_steps}</h2>
          </div>
          <div className="Result_matrix">
            <h3>Results</h3>
            <p>Here’s what we typically see in {phase} phase churches:</p>
            <ul>
              <li>
                <h5>
                  <IonIcon icon="android-search" />
                  Priority Focus
                </h5>
                <p>{priority_focus}</p>
              </li>
              <li>
                <h5>
                  <IonIcon icon="android-list" />
                  General Characteristics
                </h5>
                <p>{general_characteristics}</p>
              </li>
              <li>
                <h5>
                  <IonIcon icon="android-bookmark" />
                  Foundations
                </h5>
                <p>{foundations}</p>
              </li>
              <li>
                <h5>
                  <IonIcon icon="person-stalker" />
                  Leadership
                </h5>
                <p>{leadership}</p>
              </li>
              <li>
                <h5>
                  <IonIcon icon="map" />
                  Ministry Strategy
                </h5>
                <p>{ministry_strategy}</p>
              </li>
              <li>
                <h5>
                  <IonIcon icon="podium" />
                  Systems
                </h5>
                <p>{systems}</p>
              </li>
              <li>
                <h5>
                  <IonIcon icon="ios-people" />
                  Staffing & Structure
                </h5>
                <p>{staffing_structure}</p>
              </li>
              <li>
                <h5>
                  <IonIcon icon="social-usd" />
                  Finances
                </h5>
                <p>{finances}</p>
              </li>
            </ul>
          </div>
          <div className="Result_recommend">
            <p className="Result_prompt">
              View your full report for a detailed analysis of {phase} phase and
              practical next steps.
            </p>
            <Button
              onClick={resultStore.createResultsPDF}
              styleType="primary"
              className="Result_download"
              download
            >
              {resultStore.generatingPDF && <IonIcon icon="load-a" />}
              Download full report
            </Button>

            <p className="Result_disclaimer">
              Disclaimer: Your results are based on the data and opinions you
              entered. For an in-depth analysis of where your church sits in its
              life cycle, consider engaging an outside perspective to assess
              your church on-site. Our{" "}
              <a target="_blank" href="https://theunstuckgroup.com/assessment/">
                Ministry Health Assessment
              </a>{" "}
              is designed to do just that.
            </p>
          </div>
          <div className="Result_footer">
            <img
              src={bookImg}
              alt="The Unstuck Church: Equipping Churches to Experience Sustained Health"
            />
            <p>
              Learn more about all seven phases in the life cycle of a typical
              church in{" "}
              <a target="_blank" href={BOOK_LINK}>
                The Unstuck Church: Equipping Churches to Experience Sustained
                Health
              </a>{" "}
              by{" "}
              <a target="_blank" href="https://tonymorganlive.com/about/">
                Tony Morgan
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

Result.displayName = "Result";

export default observer(Result);



// WEBPACK FOOTER //
// ./src/result/Result.js